export default () => {
  const modalWrapper = document.querySelector(".js-terms-modal");

  // Exit if the modal is not present
  if (!modalWrapper) return;

  const disclaimerExists = localStorage.getItem("disclaimer") !== null;
  const acceptButton = modalWrapper.querySelector(".js-accept_terms");

  // Only show modal if disclaimer is not set at all
  if (!disclaimerExists) {
    modalWrapper.classList.remove("dialog_hidden");
    modalWrapper.setAttribute("aria-hidden", "false");
  }

  acceptButton?.addEventListener("click", () => {
    console.log('%cfrontend/stewart-title/js/components/TermsOfUse/initTermsOfUse.js:17 object', 'color: #007acc;', "hello world");
    localStorage.setItem("disclaimer", "Accepted");
    modalWrapper.classList.add("dialog_hidden");
    modalWrapper.setAttribute("aria-hidden", "true");
  });
};
